import { CloseOutlined, MenuOutlined } from '@ant-design/icons';
import { Button, Col, Drawer, Flex, Row, Typography } from 'antd';
import { localize } from 'mixins/helpers';
import React, { useEffect, useState } from 'react';
import MobilePhoneIcon from '../../../assets/svg/mobile-phone.svg';
import MailIcon from 'assets/svg/svg1.svg';
import PhoneIcon from '../../../assets/svg/phone.svg';
import ContactCenter from '../contact-center/contact-center';
import { getMenuList } from '/react4xp/parts/service-link-img/actions';

const KGD_INFO_URL = 'https://www.gov.kz/org/kgd?lang=ru';

const KGD_INFO_TITLES = {
    ru: 'Информационный раздел КГД',
    kk: 'МКК ақпараттық бөлімі',
    en: 'SRC Information Section',
};

const HeaderMobileMenu = (props) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const openMenu = () => setIsMenuOpen(true);
    const closeMenu = () => setIsMenuOpen(false);

    const [menuItems, setMenuItems] = useState([]);

    useEffect(() => {
        getMenuList(props.context).then((value) => {
            if (value.data) {
                setMenuItems(value.data.filter((x) => !x.dataAsJson.menu));
            }
        });
    }, []);

    const getMenuItemHref = (path) => {
        return '/' + props.language + path.replace('/isna-portal-cms', '');
    };

    const language = String(props.language || 'ru')
        .toLowerCase()
        .split(/[-_]/)[0];

    const title =
        KGD_INFO_TITLES[language] || KGD_INFO_TITLES.ru;

    const items = menuItems.map((item) => ({
        key: item.id,
        title: item.displayName,
        href: getMenuItemHref(item._path),
        external: false,
    }));

    const externalItem = {
        key: 'kgd-info-section',
        title,
        href: KGD_INFO_URL,
        external: true,
    };

    const knowledgeBaseIndex = items.findIndex((item) => {
        const name = String(item.title).toLowerCase();

        return (
            name.includes('база знаний') ||
            name.includes('білім') ||
            name.includes('knowledge')
        );
    });

    if (knowledgeBaseIndex !== -1) {
        items.splice(knowledgeBaseIndex + 1, 0, externalItem);
    } else {
        items.push(externalItem);
    }

    return (
        <>
            <Button
                onClick={openMenu}
                type={'text'}
                size={'large'}
                icon={<MenuOutlined className="header_menu_button__icon" />}
                className="header_menu_button"
            >
                {!props.user && localize('bvi-menu', props.translations)}
            </Button>
            <Drawer
                placement={'top'}
                open={isMenuOpen}
                onClose={closeMenu}
                closable={{
                    closeIcon: <CloseOutlined style={{ color: 'white' }} />,
                }}
                style={{ backgroundColor: '#164B84', color: 'white', fontSize: 20 }}
                height={300}
                getContainer={() => document.getElementById('root')}
            >
                <Row gutter={[20, 20]}>
                    <Col xs={24}>
                        <Typography.Text
                            style={{
                                color: 'white',
                                marginBottom: 10,
                                display: 'block',
                            }}
                        >
                            {localize('header-contact-center', props.translations)}
                        </Typography.Text>
                        <Flex
                            gap={10}
                            wrap="wrap"
                        >
                            <ContactCenter
                                config={{
                                    phone: props.config.short_phone,
                                }}
                                icon={<MobilePhoneIcon />}
                            />
                            <ContactCenter
                                config={{
                                    phone: props.config.long_phone,
                                }}
                                icon={<PhoneIcon />}
                            />
                            <ContactCenter
                                config={{
                                    mail: props.config.knpsd,
                                }}
                                icon={<MailIcon />}
                            />
                            {props.config.videoCallText && props.config.videoCallUrl && (
                                <ContactCenter
                                    config={{
                                        phone: props.config.videoCallText,
                                        url: props.config.videoCallUrl,
                                        qrSrc: props.videoCallQrUrl,
                                    }}
                                    src={props.videoCallIconUrl}
                                />
                            )}
                        </Flex>
                    </Col>

                    <Col xs={13}>
                        <Flex
                            vertical
                            gap={20}
                        >
                            {items.slice(0, 3).map((item) => (
                                <a
                                    key={item.key}
                                    href={item.href}
                                    target={item.external ? '_blank' : undefined}
                                    rel={item.external ? 'noopener noreferrer' : undefined}
                                >
                                    {item.title}
                                </a>
                            ))}
                        </Flex>
                    </Col>

                    <Col xs={11}>
                        <Flex
                            vertical
                            gap={20}
                        >
                            {items.slice(3).map((item) => (
                                <a
                                    key={item.key}
                                    href={item.href}
                                    target={item.external ? '_blank' : undefined}
                                    rel={item.external ? 'noopener noreferrer' : undefined}
                                >
                                    {item.title}
                                </a>
                            ))}
                        </Flex>
                    </Col>
                </Row>
            </Drawer>
        </>
    );
};

export default HeaderMobileMenu;
